export default [
  {
    path: 'billing',
    component: () => import('@/views/Billing'),
    children: [
      {
        name: 'billing/account',
        path: 'account',
        component: () => import('@/views/Billing/Account'), 
      },
      {
        name: 'billing/history',
        path: 'history',
        component: () => import('@/views/Billing/History'), 
      },
      {
        name: 'billing/history/dispute',
        path: 'history/dispute',
        component: () => import('@/views/Billing/History/Dispute'), 
      },
      {
        name: 'history/dispute/create',
        path: 'billing/history/dispute/:lead_id(\\d+)',
        component: () => import('@/views/Billing/History/Dispute/Create'), 
        props: true,
      },
      {
        name: 'history/dispute/confirm',
        path: 'billing/history/dispute/confirm',
        component: () => import('@/views/Billing/History/Dispute/Confirm'), 
      },
      {
        name: 'billing/statements',
        path: 'statements',
        component: () => import('@/views/Billing/Statements/List'), 
      },
      {
        name: 'billing/statements/show',
        path: 'billing/statements/:invoice_id',
        component: () => import('@/views/Billing/Statements/Show'), 
        props: true,
      },
      {
        name: 'billing/payments',
        path: 'payments',
        component: () => import('@/views/Billing/Payments'), 
      },
    ],
  },
  {
    name: 'billing/add_balance',
    path: 'account/add_balance',
    component: () => import('@/views/Billing/Account/AddBalance'), 
  },
  {
    name: 'billing/auto_refill',
    path: 'account/auto_refill',
    component: () => import('@/views/Billing/Account/AutoRefill'), 
  },
  {
    name: 'billing/new_payment_method',
    path: 'account/new_method',
    component: () => import('@/views/Billing/NewPaymentMethod'), 
  },
  {
    name: 'payments/show',
    path: 'payments/:payment_id',
    component: () => import('@/views/Billing/Payments/Show'), 
    props: true,
  },
  {
    name: 'reactivate',
    path: 'reactivate',
    component: () => import('@/views/Billing/Reactivate'),
  },
  {
    name: 'reactivate/confirm',
    path: 'reactivate/confirm',
    component: () => import('@/views/Billing/Reactivate/Confirm'),
  },
]